import { render, staticRenderFns } from "./AccountSupportContent.vue?vue&type=template&id=31cc0f79&scoped=true"
import script from "./AccountSupportContent.vue?vue&type=script&lang=js"
export * from "./AccountSupportContent.vue?vue&type=script&lang=js"
import style0 from "./AccountSupportContent.vue?vue&type=style&index=0&id=31cc0f79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cc0f79",
  null
  
)

export default component.exports